/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSubEvaluationOutputDimGrades } from './oralExamSubEvaluationOutputDimGrades';
import type { OralExamSubEvaluationOutputQuestionFeedback } from './oralExamSubEvaluationOutputQuestionFeedback';

/**
 * Per-question oral exam rating for student-facing API.
 */
export interface OralExamSubEvaluationOutput {
  id: string;
  dimGrades: OralExamSubEvaluationOutputDimGrades;
  questionFeedback?: OralExamSubEvaluationOutputQuestionFeedback;
}
